import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { RESERVATIONS_PATH } from '../../core/constants';

export const updateReservationStoreStatusAction = createAsyncThunk(
    'reservation/updateReservationStoreStatusAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ RESERVATIONS_PATH }/${ data.reservationId }/change-status`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateReservationStoreStatusSlice = createSlice({
    name: 'updateReservationStoreStatusSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateReservationStoreStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateReservationStoreStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateReservationStoreStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateReservationStoreStatusState = (state) => state.reservation.updateReservationStoreStatus;
export default updateReservationStoreStatusSlice.reducer;
